import { useCallback } from 'react';
import { usePreference } from '@frontend/user-preferences';

export const usePreferredOutboundNumberUserSettings = () => {
  const [preferredOutboundLocationPhone = {}, setPreferredOutboundLocationPhone] = usePreference(
    'PreferredOutboundLocationPhone'
  );

  const getPreferredOutboundNumberForLocation = useCallback(
    (locationId: string) => preferredOutboundLocationPhone[locationId] ?? '',
    [preferredOutboundLocationPhone]
  );

  const setPreferredOutboundNumberForLocation = useCallback(
    (locationId: string, locationPhone: string) => {
      const updatedPreference = {
        ...preferredOutboundLocationPhone,
        [locationId]: locationPhone,
      };
      setPreferredOutboundLocationPhone(updatedPreference);
    },
    [preferredOutboundLocationPhone, setPreferredOutboundLocationPhone]
  );

  return {
    getPreferredOutboundNumberForLocation,
    setPreferredOutboundNumberForLocation,
  };
};
